<template>
  <div>
    <div style="height: 20px;"></div>
    <template v-for="(item, idx) in detailData">
      <div class="row-content" :key="idx">
        <div class="detail-label">{{ item.label }}：</div>
        <div class="detail-value">{{ detailGetData[item.value] }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "detail-info",
  props: {
    title: String,
    detailData: Array,
    detailGetData: Object
  }
};
</script>

<style scoped lang="scss">
.detail-label,
.detail-value {
  font-size: 13px;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 17px;
  /deep/ .el-button {
    margin-left: 21px;
  }
}
.row-content {
  display: flex;
  margin-bottom: 20px;
}
.detail-label {
  width: 160px;
  text-align: right;
}
.detail-value {
  width: calc(100% - 234px);
  padding-right: 54px;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}
.categoryBos-wrapper {
}
.detail-lableImg {
  cursor: pointer;
  width: 200px;
  height: 60px;
  position: relative;
  img {
    width: 200px;
    height: 60px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.detail-bottom {
  padding: 0 49px;
  .el-row {
    flex-wrap: wrap;
    .el-col {
      margin-top: 20px;
    }
  }
  .bottom-img {
    cursor: pointer;
    width: 103px;
    height: 140px;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bottom-text {
    span {
      display: block;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4a4a4a;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
